import {
    useState,
    useRef,
} from 'react';
import classNames from 'classnames';

import { useOutsideClick } from 'hooks';

import StyledDropdown from './styles';

const Dropdown = ({ Trigger, children, className = '' }) => {
    const [toggleDropdown, setToggleDropdown] = useState();
    const ref = useRef(null);
    useOutsideClick(ref, () => setToggleDropdown(false));

    const TriggerComponent = () => <Trigger />;

    return (
        <StyledDropdown
            ref={ref}
            onClick={() => setToggleDropdown((prev) => !prev)}
            className={classNames(`${className}`, {
                active: toggleDropdown,
            })}
        >
            <div className="title trigger">
                <TriggerComponent />
            </div>
            {toggleDropdown && (
                <ul className="dropdown-container">
                    { children }
                </ul>
            )}
        </StyledDropdown>
    );
};

export default Dropdown;
